/*
 * @Descripttion: 
 * @version: 
 * @Author: TangXihao
 * @Date: 2021-05-20 10:18:02
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-07-20 09:58:12
 */
import axios from 'axios'
import {message} from 'antd'
import store from '../../../../store'
import {getCookie} from "../../../../utils/checkCookie";
import {SetSearchRules02} from 'src/store/actionCreators';
import WKT from "terraformer-wkt-parser"


const url = global.dataurl.wp

/**
 * 获取数据瓦片的卫星种类
 * @returns
 */
export async function getCorrectedTileMap() {
    return new Promise((resolve, reject) => {
        axios.get(url + '/getCorrectedTileMap').then((res) => {
            let data = res.data
            if (data.code === 0) {
                resolve(data.data) //返回一个数组  
            } else {
                reject()
            }
        }).catch((e) => {
            reject(e) //reject 需要用catch 去接
        })
    })
}

/**
 * 获取数据瓦片中某种卫星的传感器种类
 * @param {*} satelliteid  种类名称
 * @returns
 */
export async function getSensorbyTileSatelliteID(satelliteid) {
    return new Promise((resolve, reject) => {
        axios.get(url + '/getSensorbyTileSatelliteID?satelliteid=' + satelliteid).then((res) => {
            let data = res.data
            if (data.code === 0) {
                resolve(data.data) //返回一个数组   传感器种类
            } else {
                reject()
            }
        }).catch((e) => {
            reject(e)
        })
    })
}

/**
 * 根据查询条件获取瓦片数据
 * @param {*} searchrules
 * @returns
 */
export async function getTilesData(searchrules) {
    return new Promise((resolve, reject) => {
        axios.get(url + '/getTilesData', searchrules).then((res) => {
            let data = res.data
            if (data.code === 0) {
                resolve(data.data)
            } else {
                reject()
            }
        }).catch((e) => {
            reject(e)
        })
    })
}

/**
 * 根据查询条件获取相关格子里的瓦片数量
 * @param {*} searchrules
 * @returns
 */
export async function getTileCountBatch(searchrules) {
    return new Promise((resolve, reject) => {
        axios.get(url + '/getTileCountBatch', searchrules).then((res) => {
            let data = res.data
            if (data.code === 0) {
                resolve(data.data)
            } else {
                reject()
            }
        }).catch((e) => {
            reject(e)
        })
    })
}

/**
 * 瓦片单时相全覆盖
 * @param {*} searchrules
 * @returns
 */
export async function SearTileBatchAllType(searchrules) {
    return new Promise((resolve, reject) => {
        axios.get(url + '/SearTileBatchAllType', searchrules).then((res) => {
            let data = res.data
            if (data.code === 0) {
                resolve(data.data)
            } else {
                reject()
            }
        }).catch((e) => {
            reject(e)
        })
    })
}

//-------------------------------------------------------------------
//-------------------------------------------------------------------
//-------------------------------------------------------------------
//-------------------------------------------------------------------
/**
 * 获取光学数据字典中卫星对应关系
 * @returns
 */
export async function getAllOpticalMap() {
    return new Promise((resolve, reject) => {
        axios.get(url + '/getAllOpticalMap').then((res) => {
            let data = res.data
            if (data.code === 0) {
                resolve(data.data)
            } else {
                reject()
            }
        }).catch((e) => {
            reject(e)
        })
    })
}

/**
 * 获取指定卫星的传感器类型(载荷？)，使用getAllOpticalMap接口中返回的tableName值。
 * @returns
 */
export async function getSensorbySatellite(satelliteid) {
    return new Promise((resolve, reject) => {
        axios.get(url + '/getSensorbySatellite', {satelliteid: satelliteid}).then((res) => {
            let data = res.data
            if (data.code === 0) {
                resolve(data.data)
            } else {
                reject()
            }
        }).catch((e) => {
            reject(e)
        })
    })
}

/**
 * 获取行政区划GeoJson。
 * @param {*} location  行政区域 {"provinceName":"string",  "cityName":"string","townName":"string"}
 * @returns
 */
export async function getAdminDivisionJson(location) {
    return new Promise((resolve, reject) => {
        axios.get(url + '/getAdminDivisionJson', location).then((res) => {
            let data = res.data
            if (data.code === 0) {
                resolve(data.data)
            } else {
                reject()
            }
        }).catch((e) => {
            reject(e)
        })
    })
}

/**
 * 根据查询条件获取光学数据
 * @param {*} searchrules 查询条件
 * @returns
 */
export async function getopticalDatas(searchrules) {
    return new Promise((resolve, reject) => {
        axios.get(url + '/getopticalDatas', searchrules).then((res) => {
            let data = res.data
            if (data.code === 0) {
                resolve(data.data)
            } else {
                reject()
            }
        }).catch((e) => {
            reject(e)
        })
    })
}

/**
 * 获取指定卫星的数据详情。    ????干嘛的
 * @param {*}
 * @returns
 */
export async function getOpticalDatasbyClick(param) {
    return new Promise((resolve, reject) => {
        axios.get(url + '/getOpticalDatasbyClick', param).then((res) => {
            let data = res.data
            if (data.code === 0) {
                resolve(data.data)
            } else {
                reject()
            }
        }).catch((e) => {
            reject(e)
        })
    })
}

/**
 * 根据查询条件获取光学数据用于全覆盖。
 * @param {*}
 * @returns
 */
export async function getOpticalFullCover(param) {
    return new Promise((resolve, reject) => {
        axios.get(url + '/getOpticalFullCover', param).then((res) => {
            let data = res.data
            if (data.code === 0) {
                resolve(data.data)
            } else {
                reject()
            }
        }).catch((e) => {
            reject(e)
        })
    })
}

/**
 * 02检索
 * @param {*} rules 检索条件
 * @returns 检索结果
 */
export async function searchData02(rules) {
    return new Promise((resolve, reject) => {
        axios({
            url: global.url.demo + '/t02/getopticalDatas',
            method: 'post',
            data: rules
        }).then(res => {
            let data = res.data
            if (data.code === "0") {
                resolve(data.payload)
            } else {
                reject("检索错误")
            }
        }).catch(e => {
            reject(e)
        })
    })
}

/**
 * 35景检索
 * @param {*} rules 检索条件
 * @returns 检索结果
 */
export async function searchScene35(rules) {
    return new Promise((resolve, reject) => {
        axios({
            url: global.url.demo + '/scene/getScene',
            method: 'post',
            data: rules
        }).then(res => {
            let data = res.data
            if (data.code === "0") {
                resolve(data.payload)
            } else {
                reject("检索错误")
            }
        }).catch(e => {
            reject(e)
        })
    })
}

/**
 * 35瓦片检索
 * @param {*} rules 检索条件
 * @returns 检索结果
 */
export async function searchTiles35(rules) {
    return new Promise((resolve, reject) => {
        axios({
            url: global.url.demo + '/tile/getTilesData',
            method: 'post',
            data: rules
        }).then(res => {
            let data = res.data
            if (data.code === "0") {
                resolve(data.payload)
            } else {
                reject("检索错误")
            }
        }).catch(e => {
            reject(e)
        })
    })
}

/**
 * 遥感数据检索
 * @param {*} rules 检索条件
 * @param {*} type 检索类型 1岩矿2土壤3地表4水体
 * @returns 检索结果
 */
export async function searchDataYG(rules, type) {
    switch (type) {
        case "岩矿遥感光谱特征数据":
            return new Promise((resolve, reject) => {
                axios({
                    url: global.url.demo + '/rsfeatures/getmineral',
                    method: 'get',
                    data: rules
                }).then(res => {
                    let data = res.data
                    if (data.code === "200") {
                        resolve(data.payload)
                    } else {
                        reject("检索错误")
                    }
                }).catch(e => {
                    reject(e)
                })
            })
        case "土壤遥感光谱特征数据":
            return new Promise((resolve, reject) => {
                axios({
                    url: global.url.demo + '/rsfeatures/getsoil',
                    method: 'get',
                    data: rules
                }).then(res => {

                    let data = res.data
                    if (data.code === "200") {
                        resolve(data.payload)
                    } else {
                        reject("检索错误")
                    }
                }).catch(e => {
                    reject(e)
                })
            })
        case "地表大气光谱特征数据":
            return new Promise((resolve, reject) => {
                axios({
                    url: global.url.demo + '/rsfeatures/getsurface',
                    method: 'get',
                    params: rules
                }).then(res => {

                    let data = res.data
                    if (data.code === "200") {
                        resolve(data.payload)
                    } else {
                        reject("检索错误")
                    }
                }).catch(e => {
                    reject(e)
                })
            })
        case "水体光谱特征数据":
            return new Promise((resolve, reject) => {
                axios({
                    url: global.url.demo + '/rsfeatures/getwater',
                    method: 'get',
                    data: rules
                }).then(res => {

                    let data = res.data
                    if (data.code === "200") {
                        resolve(data.payload)
                    } else {
                        reject("检索错误")
                    }
                }).catch(e => {
                    reject(e)
                })
            })
        case "植被遥感光谱特征数据":
            return new Promise((resolve, reject) => {
                axios({
                    url: global.url.demo + '/rsfeatures/getplant',
                    method: 'get',
                    data: rules
                }).then(res => {

                    let data = res.data
                    if (data.code === "200") {
                        resolve(data.payload)
                    } else {
                        reject("检索错误")
                    }
                }).catch(e => {
                    reject(e)
                })
            })
        default:
            return Promise.reject('类型查询错误')
    }
}

/**
 *
 * @param {*} page 查询的页数
 * @param {*} resourceType 0为0-2购物车数据，1为3-5数据
 * @returns 返回查询结果
 */
export async function getCart(page, resourceType) {
    return new Promise((resolve, reject) => {
        axios({
            url: global.url.order + '/shop/myshop',
            method: 'get',
            params: {
                userId: store.getState().userReducer.get('user').toJS().userId,
                // resourceType: resourceType,
                page: page,
                limit: 9999
            }
        }).then(res => {
            if (res.data.code === '200') {
                // console.log('检查是否存在购物车条目总数:',res.data.payload);
                resolve(res.data.payload.records)
            } else
                reject('购物车加载失败')
        }).catch(err => {
            reject(err)
        })
    })
}

export async function getCartTotalNum() {
    return new Promise((resolve, reject) => {
        axios({
            url: global.url.order + '/shop/myshop',
            method: 'get',
            params: {
                userId: store.getState().userReducer.get('user').toJS().userId,
                // resourceType: resourceType,
                page: 1,
                limit: 10
            }
        }).then(res => {
            if (res.data.code === '200') {
                // console.log('检查是否存在购物车条目总数:',res.data.payload);
                resolve(res.data.payload.total)
            } else
                reject('购物车加载失败')
        }).catch(err => {
            reject(err)
        })
    })
}

/**
 * 将02数据添加至购物车
 * @param {*} data 加购物车的数据条
 * @returns {boolean} 加购物车结果
 */
export async function saveCart02(data) {
    return new Promise((resolve, reject) => {
        axios({
            url: global.url.order + '/shop/save02?userId=' + store.getState().userReducer.get('user').toJS().userId,
            method: 'post',
            data: [data]
        }).then(res => {
            if (res.data.code === '200') {
                resolve(true)
            } else {
                resolve(false)
            }
        }).catch(err => {
            reject(err)
        })
    })
}

/**
 * 将35景产品数据添加至购物车
 * @param {*} data 加购物车的数据条
 * @returns {boolean} 加购物车结果
 */
export async function saveCartJing35(data) {
    return new Promise((resolve, reject) => {
        axios({
            url: global.url.order + '/shop/saveScene?userId=' + store.getState().userReducer.get('user').toJS().userId,
            method: 'post',
            data: [data]
        }).then(res => {

            if (res.data.code === '200') {
                resolve(true)
            } else {
                resolve(false)
            }
        }).catch(err => {
            reject(err)
        })
    })
}

export async function removeCart(shopList, data) {
    return new Promise((resolve, reject) => {
        if (data.shopId) {
            axios({
                url: global.url.order + '/shop/delete',
                method: 'delete',
                params: {
                    ids: data.shopId
                }
            }).then(res => {
                if (res.data.code === '200') {
                    resolve(true)
                } else {
                    reject(false)
                }
            }).catch(err => {
                reject(false)
            })
        } else {
            // let indexData = isEqul(shopList, data)
            let indexData = ''
            if (data.resourceType === "高程数据" || data.resourceType === "矢量数据") {
                indexData = isEqul(shopList, data)
            } else {
                indexData = shopList.find(item => {
                    return item.fileName == data.sitenumber || item.fileName === data.spectraldata;
                });
            }

            axios({
                url: global.url.order + '/shop/delete',
                method: 'delete',
                params: {
                    ids: indexData.shopId
                }
            }).then(res => {
                if (res.data.code === '200') {
                    resolve(true)
                } else {
                    reject(false)
                }
            }).catch(err => {
                reject(false)
            })
        }
    })
}

export async function getUserScore() {
    // const { token } = this.props;

    return new Promise((resolve, reject) => {
        axios({
                url: global.url.score + '/score/getbyid',
                method: 'get',
                params: {
                    userId: store.getState().userReducer.get('user').toJS().userId,
                },
                headers: {
                    'Authorization': store.getState().userReducer.get('user').toJS().token
                }
            }
        ).then(res => {

            if (res.data.code === '200' && res.data.payload) {

                resolve(res.data.payload.score)
            } else {
                reject(res)
            }
        }).catch(err => {
            reject(err)
        })
    })
}

export function payForOrder_cart(shopIds) {

    return new Promise((resolve, reject) => {
        axios({
            url: global.url.order + '/order/download/shopsave',
            method: 'post',
            data: shopIds
        }).then(res => {

            if (res.data.code === '200') {
                resolve(true)
            } else {
                reject(false)
            }
        }).catch(err => {
            console.log(err)
            reject(err)
        })
    })
}

export function payForOrder_search(downloadOrderVOList) {
    downloadOrderVOList.map(element => {
        if (element.resourceType === '高程数据') {
            return element.fileName += '.zip'
        }
    });
    console.log('下载数据：', downloadOrderVOList);
    return new Promise((resolve, reject) => {
        axios({
            url: global.url.order + '/order/download/save',
            method: 'post',
            data: downloadOrderVOList
        }).then(res => {

            if (res.data.code === '200') {
                resolve(true)
            } else {
                reject(false)
            }
        }).catch(err => {
            console.log(err)
            reject(err)
        })
    })
}

/**
 * 判断查询购物车列表datalist中是否包含id与data.id相同的数据
 * @param {*} datalist 购物车列表
 * @param {*} data 查询元数据
 * @returns 查询列表中存在id相同的数据返回true，否则返回false
 */
export function isEqul(datalist, data) {
    // console.log("isEqul", datalist, data);
    let flag = null
    datalist.map((value, index) => {
        if (value.fileName === data.name || value.fileName === data.dataname) {
            flag = value
        }
    })
    return flag
}

export function base64encode(str) {
    var out, i, len, base64EncodeChars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
    var c1, c2, c3;
    len = str.length;
    i = 0;
    out = "";
    while (i < len) {
        c1 = str.charCodeAt(i++) & 0xff;
        if (i == len) {
            out += base64EncodeChars.charAt(c1 >> 2);
            out += base64EncodeChars.charAt((c1 & 0x3) << 4);
            out += "==";
            break;
        }
        c2 = str.charCodeAt(i++);
        if (i == len) {
            out += base64EncodeChars.charAt(c1 >> 2);
            out += base64EncodeChars.charAt(((c1 & 0x3) << 4) | ((c2 & 0xF0) >> 4));
            out += base64EncodeChars.charAt((c2 & 0xF) << 2);
            out += "=";
            break;
        }
        c3 = str.charCodeAt(i++);
        out += base64EncodeChars.charAt(c1 >> 2);
        out += base64EncodeChars.charAt(((c1 & 0x3) << 4) | ((c2 & 0xF0) >> 4));
        out += base64EncodeChars.charAt(((c2 & 0xF) << 2) | ((c3 & 0xC0) >> 6));
        out += base64EncodeChars.charAt(c3 & 0x3F);
    }
    return out;
}


/* 浙大数据接口————北京 */

//获取光学数据字典中卫星的名称————————停用
export function getAllSatelliteNameMap(token) {
    return new Promise((resolve, reject) => {
        axios(`/zdUrl/api/getAllSatelliteNameMap`, {
            headers: {
                Authorization: token,
            }
        }).then(res => {
            if (res.data.code === '0') {
                resolve(res.data.data)
            } else {
                message.error(res.data.info);
                reject(false)
            }
        }).catch(err => {
            console.log(err)
            reject(err)
        })
    })
}

//获取指定卫星的传感器类型——————————停用
export function getSensorbySatellite_zd(satelliteName, token) {
    return new Promise((resolve, reject) => {
        axios.get(`/zdUrl/api/getSensorbySatellite?satelliteNames=${satelliteName}`, {
            headers: {
                Authorization: token,
            }
        }).then(res => {
            if (res.data.code === '0') {
                let dataList = [];
                res.data.data.map((data) => {
                    dataList.push(data.sensorname);
                })
                resolve(dataList)
            } else {
                message.error(res.data.info);
                reject("检索错误")
            }
        }).catch(err => {
            console.log(err)
            reject(err)
        })
    })
}

/* 浙大光学卫星查询*/
let zd_02_Count = 0

export async function searchData02_zd(rules, token, sort = 1) {
    let reqUrl;
    let {satelliteidStr, sensoridStr, satelliteidobj} = dealsatelliteString(rules.satelliteSelectValue)
    let allsatelliteid = ''
    for (let value in satelliteidobj) {
        allsatelliteid = allsatelliteid + satelliteidobj[value].substring(0, satelliteidobj[value].length - 1) + ';'
    }
    let sendData = {
        "cloudRangeMax": rules.maxCloud,
        "cloudrangemin": rules.minCloud,
        "starttime": rules.fromTime ? rules.fromTime / 1000 : -1,
        "endtime": rules.endTime ? rules.endTime / 1000 : -1,
        "num": rules.num,
        "page": rules.page,
        "productid": rules.selectProductNumberType === '产品号' && rules.productNumber ? [Number(rules.productNumber)] : [],
        "rangeJson": rules.areaSelectValue.rangeJson ? rules.areaSelectValue.rangeJson : undefined,   //等待获取全球geojson后加入
        "sceneid": rules.selectProductNumberType === '景号' && rules.productNumber ? [Number(rules.productNumber)] : [],
        "searchrule": 1,        //默认相交
        "satsensor": allsatelliteid,
        "orbitid": rules.trackNum,
    }
    switch (rules.selectSensoryType) {
        case '光学传感器':
            if (rules.coverageMethod === "单次全覆盖")
                reqUrl = global.gatewayip + `/api/interface/api/getOpticalFullCover?sort=${sort}`;
            else
                reqUrl = global.gatewayip + `/api/interface/api/getopticalDatas?sort=${sort}`;
            break;
        case '大气传感器':
            reqUrl = global.gatewayip + `/api/interface/api/getGf5bDatas?sort=${sort}`;
            sendData = {
                "starttime": rules.fromTime ? rules.fromTime / 1000 : -1,
                "endtime": rules.endTime ? rules.endTime / 1000 : -1,
                "num": rules.num,
                "page": rules.page,
                "satelliteid": satelliteidStr,
                "sensorid": sensoridStr
            }
            break;
        case "雷达传感器":
            if (rules.coverageMethod === "单次全覆盖")
                reqUrl = global.gatewayip + `/api/interface/api/getMicroWaveDataFullCover?sort=${sort}`;
            else
                reqUrl = global.gatewayip + `/api/interface/api/getMicroWaveData?sort=${sort}`
            break;
        case "激光卫星数据":
            reqUrl = global.gatewayip + `/api/interface/api/getLaserData?sort=${sort}`
        default:
            break;
    }
    store.dispatch(SetSearchRules02(JSON.stringify(sendData)))
    let {data} = await axios.post(reqUrl, sendData, {
        headers: {
            Authorization: token,
        }
    })

    if (data.code === "0") {
        let returnData = {...data.data};
        let scoreData = await getScoreFromType(rules.selectSensoryType === '光学传感器' ? rules.resourceType : '微波卫星数据');
        zd_02_Count = 0
        let list = await getPngUrl02_zd(returnData, scoreData, rules, token)
        return list;
    } else {
        Error(data.info);
    }
}

export async function getPngUrl02_zd(returnData, scoreData, rules, token) {
    // debugger
    let dataNames = ''
    let dataType = rules.selectSensoryType === '光学传感器' ? 'optical' : rules.selectSensoryType === '激光卫星数据' ? '激光数据' : 'microwave';
    if (rules.selectSensoryType !== '大气传感器') {
        try {
            returnData.list.forEach((item, i) => {
                if (i == returnData.list.length - 1) {
                    dataNames += item.name
                } else {
                    dataNames += item.name + ','
                }
            })
            let dataList = await searchDataForThumbnail_zd({
                dataNames,
                dataType: dataType,
                searchType: rules.selectSensoryType
            }, token)
            returnData.list = returnData.list.map((item, i) => {
                let pngUrl
                let tempStr = item.name.slice(0, -7)
                if (rules.selectSensoryType === '激光卫星数据') {
                    for (let i in dataList) {
                        if (dataList[i][tempStr] !== undefined)
                            pngUrl = dataList[i][tempStr]["0"]
                    }
                } else
                    pngUrl = dataList[item.name]
                item.pngUrl = pngUrl
                item.resourceType = rules.resourceType
                item.score = scoreData.downloadScore
                return item
            })
        } catch (e) {
            if (zd_02_Count < 3) {
                zd_02_Count += 1
                return await getPngUrl02_zd(returnData, scoreData, rules, token)
            }
        }
    } else {
        returnData.list = returnData.list.map(item => {
            item.resourceType = rules.resourceType
            item.score = scoreData.downloadScore
            return item
        })
    }
    return returnData
}

export function dealsatelliteString(satelliteSelectValue) {
    console.log("satelliteSelectValue====", satelliteSelectValue)
    let satelliteidobj = {}
    let satelliteidStr = ''
    let sensoridStr = ''
    let satelliteidList = []
    let sensoridList = []
    satelliteSelectValue.map((value) => {
        let valueList = value.split(":");
        let satelliteid = valueList[0].split("（")[1].split("）")[0];//取括号内的卫星名
        let sensorid = valueList[1];//取冒号后的传感器名
        satelliteidStr = satelliteid
        sensoridStr = sensorid
        //特殊项检查
        switch (satelliteid) {
            case 'GF1':
                if (sensorid === 'PMS')
                    sensorid = 'PMS1,PMS2'
                else
                    sensorid = 'WFV1,WFV2,WFV3,WFV4'
                break;
            case 'GF2':
                sensorid = 'PMS1,PMS2'
                break;
            case 'HJ1A':
                if (sensorid === 'CCD')
                    sensorid = 'CCD1,CCD2'
                break;
            case 'HJ1B':
                if (sensorid === 'CCD')
                    sensorid = 'CCD1,CCD2'
                break;
            case 'HJ2A':
                if (sensorid === 'CCD')
                    sensorid = 'CCD1,CCD2,CCD3,CCD4'
                break;
            case 'HJ2B':
                if (sensorid === 'CCD')
                    sensorid = 'CCD1,CCD2,CCD3,CCD4'
                break;
            default:
                break;
        }
        if (satelliteidList.indexOf(satelliteid) === -1)
            satelliteidList.push(satelliteid)
        sensoridList.push(...sensorid.split(','))
        if (!satelliteidobj[satelliteid]) {
            satelliteidobj[satelliteid] = satelliteid + ':';
        }
        satelliteidobj[satelliteid] = satelliteidobj[satelliteid] += sensorid + ','
        // if (!sensoridList.includes(sensorid)) sensoridList.push(sensorid);
    })
    return {
        satelliteidStr: satelliteidStr,
        sensoridStr: sensoridStr,
        satelliteidobj: satelliteidobj,
        satelliteidList: satelliteidList,
        sensoridList: sensoridList
    }
}

/* 浙大3-5产品查询分类*/
export function searchData35_zd(rules, token, sort = 0) {
    let {satelliteidList, sensoridList} = dealsatelliteString(rules.satelliteSelectValue)
    rules.satelliteidList = [...satelliteidList];
    rules.sensoridList = [...sensoridList];
    if (rules.selectClass === '景产品') return searchData35_zd_Image(rules, token, sort);
    else return searchData35_zd_Tile(rules, token, sort);
}

//景产品类型接口
let zd_Image_Count = 0

export async function searchData35_zd_Image(rules, token, sort) {
    let sendData = {
        "cloudRangeMax": rules.maxCloud,
        "cloudrangemin": rules.minCloud,
        "endtime": rules.endTime ? rules.endTime / 1000 : -1,
        "starttime": rules.fromTime ? rules.fromTime / 1000 : -1,
        "num": rules.num,
        "page": rules.page,
        "rangeJson": rules.areaSelectValue.rangeJson ? rules.areaSelectValue.rangeJson : undefined,   //等待获取全球geojson后加入
        "satelliteid": [...rules.satelliteidList],
        "searchrule": 1,        //默认相交
        "sensorid": [...rules.sensoridList],
        "producetype": rules.nowSelectProductCategory,
        "producename": rules.nowSelectProductSelectType
    }
    let query = global.url.interfaceUrl + `/getimageprodData?sort=${sort}`;
    if (rules.selectMode === "单次全覆盖") {
        query = global.url.interfaceUrl + `/getImageProdFullCover?sort=${sort}`;
        if (!sendData.rangeJson) sendData.rangeJson = "{'type':'Polygon','coordinates':[[[-180,90],[180,90],[180,-90],[-180,-90],[-180,90]]]}"
    }
    let {data} = await axios.post(query, sendData, {
        headers: {
            Authorization: token,
        }
    })
    if (data.code === "0") {
        let returnData = {...data.data};
        let scoreData = await getScoreFromType(rules.resourceType);
        zd_Image_Count = 0
        let list = await getPngUrl35_zd_Image(returnData, scoreData, rules, token)
        return list;
    } else {
        Error('检索错误')
    }


    // return new Promise((resolve, reject) => {
    //     axios.post(query, sendData, {
    //         headers: {
    //             Authorization: token,
    //         }
    //     }).then(res => {
    //         let data = res.data
    //         if (data.code === "0") {
    //             let returnData = { ...data.data };

    //             async function text() {
    //                 let returnData = { ...data.data };
    //                 let scoreData = await getScoreFromType(rules.resourceType);
    //                 returnData.list.map((info) => {
    //                     async function name() {
    //                         let url = await searchDataForThumbnail_zd({
    //                             dataNames: info.name,
    //                             dataType: 'imageProd'
    //                         }, token);
    //                         let pngUrl = url[info.name];
    //                         info.pngUrl = pngUrl;
    //                     }

    //                     name();
    //                     info.resourceType = rules.resourceType;
    //                     info.score = scoreData.downloadScore
    //                 })
    //                 resolve(returnData)
    //             }

    //             text();
    //             // returnData.list.map((info) => {
    //             //     async function name() {
    //             //         let url = await searchDataForThumbnail_zd({ dataNames: info.name, dataType: 'imageProd' }, token);
    //             //         let pngUrl = url[info.name];
    //             //         info.pngUrl = pngUrl;
    //             //     }
    //             //     name();
    //             //     info.resourceType = rules.resourceType;
    //             // })
    //             // resolve(returnData)
    //         } else {
    //             message.error(data.info);
    //             reject("检索错误")
    //         }
    //     }).catch(e => {
    //         reject(e)
    //     })
    // })
}

export async function getPngUrl35_zd_Image(returnData, scoreData, rules, token) {
    let dataNames = ''
    try {
        returnData.list.forEach((item, i) => {
            if (i == returnData.list.length - 1) {
                dataNames += item.name
            } else {
                dataNames += item.name + ','
            }
        })
        let dataList = await searchDataForThumbnail_zd({
            dataNames,
            dataType: 'imageProd'
        }, token)
        returnData.list = returnData.list.map((item, i) => {
            let pngUrl = dataList[item.name].replace(/#/g, '%23')
            item.pngUrl = pngUrl
            item.resourceType = rules.resourceType
            item.score = scoreData.downloadScore
            return item
        })
    } catch {
        if (zd_Image_Count < 3) {
            zd_Image_Count += 1
            return await getPngUrl35_zd_Image(returnData, scoreData, rules, token)
        }
    }
    console.log("returnData", returnData);

    return returnData
}

//信息瓦片类型接口（数据瓦片、信息瓦片）
let zd_Tile_Count = 0

export async function searchData35_zd_Tile(rules, token, sort) {
    let sendData = {
        "cloudRangeMin": rules.minCloud,
        "cloudRangeMax": rules.maxCloud,
        "rangeJson": rules.areaSelectValue.rangeJson ? rules.areaSelectValue.rangeJson : undefined,   //等待获取全球geojson后加入
        "starttime": rules.fromTime ? rules.fromTime / 1000 : -1,
        "endtime": rules.endTime ? rules.endTime / 1000 : -1,
        "sensorid": [...rules.sensoridList],
        "satelliteid": [...rules.satelliteidList],
        "num": rules.num,
        "page": rules.page,
        "tableName": rules.tilesType,     //corrected_tiles为数据瓦片，product_tiles为信息瓦片
        "level": `${rules.level}`
    }
    let query = global.url.interfaceUrl + `/getTilesData?sort=${sort}`;
    if (rules.selectMode === "单次全覆盖") {
        query = global.url.interfaceUrl + `/searTileBatchAllType?sort=${sort}`;
        sendData.priority = 'CAT';        //在单次全覆盖中，优先级参数是必须的(这边默认：云量、满幅率、时间)
    }
    let {data} = await axios.post(query, sendData, {
        headers: {
            Authorization: token,
        }
    })
    if (data.code === "0") {
        let returnData = {...data.data};
        let scoreData = await getScoreFromType(rules.resourceType);
        zd_Tile_Count = 0
        let list = await getPngUrl35_zd_Tile(returnData, scoreData, rules, token)
        return list;
    } else {
        Error('检索错误')
    }
}

export async function getPngUrl35_zd_Tile(returnData, scoreData, rules, token) {
    let dataNames = ''
    try {
        returnData.tileData.forEach((item, i) => {
            if (i == returnData.tileData.length - 1) {
                dataNames += item.dataname
            } else {
                dataNames += item.dataname + ','
            }
        })
        console.log("dataNames", dataNames);
        let dataList = await searchDataForThumbnail_zd({
            dataNames: dataNames,
            dataType: rules.tilesType === 'product_tiles' ? 'productTile' : 'correctedTile'
        }, token)
        returnData.tileData = returnData.tileData.map((item, i) => {
            let pngUrl = dataList[item.dataname].replace(/#/g, '%23')
            item.pngUrl = pngUrl
            item.resourceType = rules.resourceType
            item.score = scoreData.downloadScore
            return item
        })
    } catch {
        if (zd_Tile_Count < 3) {
            zd_Tile_Count += 1
            return await getPngUrl35_zd_Tile(returnData, scoreData, rules, token)
        }
    }
    return returnData
}

/* ------------------------------- */

/* 浙大遥感特征数据查询*/
export async function searchDataYG_zd(rules, token) {
    let searchProductTypeValue = [
        "土壤",
        "城市",
        "南方植被",
        "北方植被",
        "岩矿",
        '大气',
        '水体'
    ];
    switch (rules.nowSelectProductTypeValue) {
        case '土壤':
        case '城市':
        case '岩矿':
            return searchDataYG_zd_Type1(rules, token);
        case '植被':
            return searchDataYG_zd_Type2(rules, token);
        case '大气':
            return searchDataYG_zd_Type3(rules, token);
        case '水体':
            return searchDataYG_zd_Type4(rules, token);
        default:
            message.error('未识别的遥感特征产品类型！');
    }
}

export async function returnDataInfoNameFormYG(rules) {
    let searchProductTypeValue = [
        "土壤",
        "城市",
        "南方植被",
        "北方植被",
        "岩矿",
        '大气',
        '水体'
    ];
    switch (rules.nowSelectProductTypeValue) {
        case '土壤':
            return 'spectraldata';
        case '城市':
            return 'spectraldata';
        case '岩矿':
            return 'rockname';
        case '植被':
            return 'spectraldata';
        case '大气':
            return 'sitenumber';
        case '水体':
            return 'soilname';
        default:
            message.error('未识别的遥感特征产品类型！');
    }
}

//遥感特征数据查询———— 土壤, 城市, 岩矿
export async function searchDataYG_zd_Type1(rules, token) {
    return new Promise((resolve, reject) => {
        axios.get(`/zdUrl/api/getSpectralCharData?dataname=${rules.nowSelectProductTypeValue}&pageNo=${rules.page}&pageNum=${rules.num}&keyword=${rules.keyword}`, {
            headers: {
                Authorization: token,
            }
        }).then(res => {
            let data = res.data
            if (data.code === "0") {
                async function text() {
                    let returnData = {...data.data};
                    let scoreData = await getScoreFromType(rules.resourceType);
                    returnData.list.map((info) => {
                        async function name() {
                            // let dataName = returnDataInfoNameFormYG(rules);
                            let dataInfoName = info['spectraldata'];
                            let preReadFile = await getPreReadFileFromType(dataInfoName, rules.nowSelectProductTypeValue, token);
                            info.preReadFile = preReadFile[dataInfoName];
                            // console.log('info.preReadFile',dataInfoName,info.preReadFile);
                        }

                        name();
                        info.resourceType = rules.resourceType;
                        info.score = scoreData.downloadScore;

                    })
                    resolve(returnData)
                }

                text();
                // resolve(data.data)
            } else {
                message.error(data.info);
                reject("检索错误")
            }
        }).catch(e => {
            reject(e)
        })
    })
}

//遥感特征数据查询———— 植被（南方植被、北方植被）
export async function searchDataYG_zd_Type2(rules, token) {     //老实说这种合并法感觉很有问题，但前端固定只有一个类型，数据却有两张表，只能先这么用着，后期再讨论
    return new Promise((resolve, reject) => {
        axios.get(`/zdUrl/api/getSpectralCharData?dataname=${'南方植被'}&pageNo=${rules.page}&pageNum=${rules.num}&keyword=${rules.keyword}`, {
            headers: {
                Authorization: token,
            }
        }).then(res => {
            let data = res.data
            if (data.code === "0") {
                axios.get(`/zdUrl/api/getSpectralCharData?dataname=${'北方植被'}&pageNo=${rules.page}&pageNum=${rules.num}&keyword=${rules.keyword}`, {
                    headers: {
                        Authorization: token,
                    }
                }).then(res2 => {
                    let data2 = res2.data
                    if (data2.code === "0") {
                        let sendData = {...data};
                        sendData.data.total += data2.data.total;
                        sendData.data.list = [...sendData.data.list, ...data2.data.list];

                        async function text() {
                            let returnData = {...sendData.data};
                            let scoreData = await getScoreFromType(rules.resourceType);
                            returnData.list.map((info) => {
                                async function name() {
                                    let dataInfoName = info['spectraldata'];
                                    let nowSelectProductTypeValue = rules.nowSelectProductTypeValue
                                    if (info['vnorthname']) nowSelectProductTypeValue = '北方植被';
                                    if (info['vsouthname']) nowSelectProductTypeValue = '南方植被';
                                    let preReadFile = await getPreReadFileFromType(dataInfoName, nowSelectProductTypeValue, token);
                                    info.preReadFile = preReadFile[dataInfoName];
                                    // console.log('info.preReadFile', info.preReadFile);
                                }

                                name();
                                info.resourceType = rules.resourceType;
                                info.score = scoreData.downloadScore;
                            })
                            resolve(returnData)
                        }

                        text();
                        // resolve(sendData.data)
                    } else {
                        message.error(data.info);
                        reject("检索错误")
                    }
                }).catch(e => {
                    reject(e)
                })
            } else {
                message.error(data.info);
                reject("检索错误")
            }
        }).catch(e => {
            reject(e)
        })
    })
}

//遥感特征数据查询———— 大气
export async function searchDataYG_zd_Type3(rules, token) {
    return new Promise((resolve, reject) => {
        axios.get(`/zdUrl/api/getSpectralCharAtmosphereData?pageNo=${rules.page}&pageNum=${rules.num}&keyword=${rules.keyword}`, {
            headers: {
                Authorization: token,
            }
        }).then(res => {
            let data = res.data
            if (data.code === "0") {
                async function text() {
                    let returnData = {...data.data};
                    let scoreData = await getScoreFromType(rules.resourceType);
                    returnData.list.map((info) => {
                        async function name() {
                            let dataInfoName = info['sitenumber'];
                            let preReadFile = await getPreReadFileFromType(dataInfoName, rules.nowSelectProductTypeValue, token);
                            info.preReadFile = preReadFile[dataInfoName];
                            // console.log('info.preReadFile', info.preReadFile);
                        }

                        name();
                        info.resourceType = rules.resourceType;
                        info.score = scoreData.downloadScore;
                    })
                    resolve(returnData)
                }

                text();
                // resolve(data.data)
            } else {
                message.error(data.info);
                reject("检索错误")
            }
        }).catch(e => {
            reject(e)
        })
    })
}

//遥感特征数据查询———— 水体
export async function searchDataYG_zd_Type4(rules, token) {
    return new Promise((resolve, reject) => {
        axios.get(`/zdUrl/api/getSpectralCharWaterData?pageNo=${rules.page}&pageNum=${rules.num}&keyword=${rules.keyword}`, {
            headers: {
                Authorization: token,
            }
        }).then(res => {
            let data = res.data
            if (data.code === "0") {
                async function text() {
                    let returnData = {...data.data};
                    let scoreData = await getScoreFromType(rules.resourceType);
                    returnData.list.map((info) => {
                        async function name() {
                            let dataInfoName = info['spectraldata'];
                            let preReadFile = await getPreReadFileFromType(dataInfoName, rules.nowSelectProductTypeValue, token);
                            info.preReadFile = preReadFile[dataInfoName];
                            // console.log('info.preReadFile', info.preReadFile);
                        }

                        name();
                        info.resourceType = rules.resourceType;
                        info.score = scoreData.downloadScore;
                    })
                    resolve(returnData)
                }

                text();
                // resolve(data.data)
            } else {
                message.error(data.info);
                reject("检索错误")
            }
        }).catch(e => {
            reject(e)
        })
    })
}

/* ---------------------------------- */

/* 浙大获取基础地理数据(基础高程数据查询、矢量数据查询接口) */
export async function searchDataJCDL_zd(rules, token) {
    if (rules.baseGeoDataType === 'DEM') return searchDataJCDL_zd_DEM(rules, token);
    else return searchDataJCDL_zd_Vector(rules, token);
}

export async function searchDataAssist(rules, token, type) {

    let {endTime, fromTime, areaSelectValue, num, page} = rules
    let sendData = {
        datatype: type,
        // endTime: endTime,
        // listA: [
        //     "string"
        // ],
        // listB: [
        //     "string"
        // ],
        // maxC: 0,
        // maxD: 0,
        // minC: 0,
        // minD: 0,
        num: num,
        page: page,
        // rangeJson: areaSelectValue.rangeJson,
        searchRule: areaSelectValue.selectTopologyType,
        // startTime: fromTime
    }
    let query = global.url.interfaceUrl + '/getAlgorithmAuxiliaryData1'
    return new Promise((resolve, reject) => {
        axios.post(query, sendData, {
            headers: {
                Authorization: token,
            }
        }).then(res => {
            let data = res.data
            if (data.code === "0") {
                async function text() {
                    let returnData = {...data.data};
                    let scoreData = await getScoreFromType(rules.resourceType);
                    returnData.list.map((info) => {
                        info.resourceType = type;
                        info.score = scoreData.downloadScore;
                    })
                    // console.log('DEM接口函数返回数据:',returnData);
                    resolve(returnData)
                }

                text();
                // resolve(data.data)
            } else {
                message.error(data.info);
                reject("检索错误")
            }
        }).catch(e => {
            reject(e)
        })
    })
}

//基础高程数据查询
export async function searchDataJCDL_zd_DEM(rules, token) {
    // console.log("全部筛选条件：",rules);
    let sendData = {
        num: rules.num,
        page: rules.page,
        // searchrule: rules.selectTopologyType,
        searchrule: rules.areaSelectValue.selectTopologyType,
        endtime: rules.endTime ? rules.endTime / 1000 : -1,
        starttime: rules.fromTime ? rules.fromTime / 1000 : -1,
        "rangeJson": rules.areaSelectValue.rangeJson ? rules.areaSelectValue.rangeJson : undefined,   //等待获取全球geojson后加入
    }
    let query = global.url.interfaceUrl + '/getDem';
    return new Promise((resolve, reject) => {
        axios.post(query, sendData, {
            headers: {
                Authorization: token,
            }
        }).then(res => {
            let data = res.data
            if (data.code === "0") {
                async function text() {
                    let returnData = {...data.data};
                    let scoreData = await getScoreFromType(rules.resourceType);
                    returnData.list.map((info) => {
                        info.resourceType = rules.resourceType;
                        info.score = scoreData.downloadScore;
                    })
                    // console.log('DEM接口函数返回数据:',returnData);
                    resolve(returnData)
                }

                text();
                // resolve(data.data)
            } else {
                message.error(data.info);
                reject("检索错误")
            }
        }).catch(e => {
            reject(e)
        })
    })
}

//矢量数据查询接口
export async function searchDataJCDL_zd_Vector(rules, token) {
    let sendData2 = {
        num: rules.num,
        page: rules.page,
        searchrule: rules.areaSelectValue.selectTopologyType,
        endtime: rules.endTime ? rules.endTime / 1000 : -1,
        starttime: rules.fromTime ? rules.fromTime / 1000 : -1,
        "rangeJson": rules.areaSelectValue.rangeJson ? rules.areaSelectValue.rangeJson : undefined,   //等待获取全球geojson后加入
    }
    let query = global.url.interfaceUrl + '/getVectorDlgData';
    return new Promise((resolve, reject) => {
        axios.post(query, sendData2, {
            headers: {
                Authorization: token,
            }
        }).then(res => {
            let data = res.data
            if (data.code === "0") {
                async function text() {
                    let returnData = {...data.data};
                    let scoreData = await getScoreFromType(rules.resourceType);
                    returnData.list.map((info) => {
                        info.resourceType = rules.resourceType;
                        info.score = scoreData.downloadScore;
                    })
                    // console.log('Vector返回数据:',returnData);
                    resolve(returnData)
                }

                text();
                // resolve(data.data)
            } else {
                message.error(data.info);
                reject("检索错误")
            }
        }).catch(e => {
            reject(e)
        })
    })
}

/* 浙大根据行政区域获取geoJson（地理范围） */
export async function searchAdminDivisionJson_zd(data, token) {
    // let sendData = {
    //     "provinceName": "string",
    //     "cityName": "string",
    //     "townName": "string"
    // }
    let query = `/zdUrl/api/getAdminDivisionJson`;
    let sendData = {};
    let dataList = data.split('/');
    if (dataList[1]) {
        sendData.provinceName = dataList[1];
        query += `?provinceName=${sendData.provinceName}`;
    }
    if (dataList[2]) {
        if (dataList[2] === '市辖区') dataList[2] = dataList[1];
        sendData.cityName = dataList[2];
        query += `&cityName=${sendData.cityName}`;
    }
    if (dataList[3]) {
        sendData.townName = dataList[3];
        query += `&townName=${sendData.townName}`;
    }
    if (dataList[0] === '中国' && !dataList[1]) {
        sendData.provinceName = dataList[0];
        query = `/zdUrl/api/getAdminDivisionJson` + `?provinceName=${sendData.provinceName}`;
    }
    return new Promise((resolve, reject) => {
        axios.get(query, {
            headers: {
                Authorization: token,
            }
        }).then(res => {
            let data = res.data
            if (data.code === "0") {
                if (!data.data) return;
                resolve(data.data.json)
            } else {
                message.error(data.info);
                reject("检索错误")
            }
        }).catch(e => {
            reject(e)
        })
    })
}

/* 浙大根据场站区域名列表获取geoJson（地理范围） */
export async function searchStationAreaJson_zd(data, token, radioType) {
    // let sendData = {
    //     "provinceName": "string",
    //     "cityName": "string",
    //     "townName": "string"
    // }
    return new Promise(async (resolve, reject) => {
        // let geoJson = undefined;
        let geoJson = {
            "type": "MultiPolygon",
            "coordinates": [],
        };
        try {
            let count = 0;
            let jsonString = await searchStationAreaJsonForOne_zd(data, token, radioType);
            let jsonString2 = JSON.parse(jsonString);
            if (jsonString2.type === 'Polygon')
                jsonString2.coordinates = [jsonString2.coordinates]//Polygon类型区域只有一层，为了转MultiPolygon，需要在Polygon外包一层数组，因为MultiPolygon的格式为：区域-子区域-点集，而Polygon为：区域-点集
            geoJson.coordinates = jsonString2.coordinates
            console.log(geoJson)
            resolve(JSON.stringify(geoJson))
        } catch (error) {
            reject('检索错误')
        }
    })
}

/* 浙大根据场站区域名获取geoJson（地理范围） */
export async function searchStationAreaJsonForOne_zd(data, token, radioType) {
    let query
    if (radioType === '站点')
        query = `${window.url.interfaceUrl}/getStationSampleJson?mode=station`;
    else
        query = `${window.url.interfaceUrl}/getStationSampleJson?mode=sample `;
    return new Promise((resolve, reject) => {
        axios.post(query,
            data,
            {
                headers: {
                    Authorization: token
                }
            }
        ).then(res => {
            console.log('kk', res)
            let data = res.data
            if (data.code === "0") {
                if (!data.data) return;
                resolve(data.data.json)
            } else {
                message.error(data.info);
                reject("检索错误")
            }
        }).catch(e => {
            reject('检索错误')
        })
    })
}


/* 浙大根据文件名获取略缩图 */
export async function searchDataForThumbnail_zd(rules, token) {
    // let sendName = rules.dataNames.replace(/#/g, '%23');
    // console.log('3-5查询条件检查（提交接口前）：', rules);
    let sendName = rules.dataNames;
    // let query = `/zdUrl/api/getThumbPath?dataType=${rules.dataType}&dataNames=` + sendName;
    let query = rules.searchType === '激光卫星数据' ? global.url.interfaceUrl + `/getLaserGraphicPath?dataNames=${sendName}&dataType=${rules.dataType}` : global.url.interfaceUrl + `/getThumbPath?dataType=${rules.dataType}&dataNames=${sendName}`;
    // let query = `/zdUrl/api//getThumbPath?dataType=${rules.dataType}&dataNames=${sendName}`;
    return new Promise((resolve, reject) => {
        // console.log('检查所过来的token：', token);
        axios.get(query, {
            headers: {
                Authorization: token,
            }
        }).then(res => {

            let data = res.data
            if (data.code === "0") {
                let returnData = {...data.data};
                for (let i in returnData) {
                    if (rules.searchType === '激光卫星数据') {
                        for (let j in returnData[i]) {
                            console.log(returnData[i][j])
                            for (let m in returnData[i][j]) {
                                if (typeof returnData[i][j][m] === 'string')
                                    returnData[i][j][m] = returnData[i][j][m].replace("http://10.0.121.14:8084", "https://caplos.aircas.ac.cn/zdTiles").replace(/#/g, '%23');
                            }
                        }
                    } else
                        returnData[i] = returnData[i].replace("http://10.0.121.14:8084", "https://caplos.aircas.ac.cn/zdTiles").replace(/#/g, '%23');
                }
                resolve(returnData)
            } else {
                console.log('message.error(data.info);检查报6错误', data.info)
                message.error(data.info);
                reject("检索错误")
            }
        }).catch(e => {
            reject(e)
        })
    })
}

/* 浙大根据文件名获取贴图（贴在球上） */
export async function searchDataForChartlet_zd(rules, token) {
    let sendName = rules.dataNames.replace(/#/g, '%23');
    // http://caplos.aircas.ac.cn/gateway/api/interface/api/getGraphicPath?dataNames=${sendName}&dateType=${rules.dataType}
    let query = window.gatewayip + `/api/interface/api/getGraphicPath?dataNames=${sendName}&dateType=${rules.dataType}`
    return new Promise((resolve, reject) => {
        axios.get(query, {
            headers: {
                Authorization: token,
            }
        }).then(res => {
            let data = res.data
            if (data.code === "0") {
                resolve(data.data)
            } else {
                message.error(data.info);
                reject("检索错误")
            }
        }).catch(e => {
            reject(e)
        })
    })
}

//从浙大查询出来的数据的属性geom中，获取地球的贴图坐标
export function getPositionsFromData_zd(geom) {
    let positions = [];
    // console.log(geom)
    let geoData = JSON.parse(geom).coordinates[0];
    // console.log(geoData)
    positions = returnMinOrMaxFromLonLatList(geoData);
    // console.log(positions)
    return positions;
}

// export function getPositionsFromData_zd_polygon(geom) {
//     let positions = [];
//     if (geom) {
//         let geoData = JSON.parse(geom).coordinates[0];
//         for (let i = 0; i < 5; i++) {
//             positions.push.apply(positions, geoData[i])
//         }

//     }
//     return positions
// }
export function getPositionsFromData_zd_polygon(geom) {
    let positions = [];

    if (geom) {
        const geoData = JSON.parse(geom);

        switch (geoData.type) {
            case "Point":
                // 处理 Point 类型，返回单个坐标点
                positions = geoData.coordinates;
                break;

            case "LineString":
                // 处理 LineString 类型，返回一条线上的所有坐标
                positions = geoData.coordinates;
                break;

            case "Polygon":
                // 处理 Polygon 类型，返回所有环的坐标
                geoData.coordinates.forEach(ring => {
                    positions.push(...ring); // 展开每个环的坐标
                });
                break;

            case "MultiPoint":
                // 处理 MultiPoint 类型，返回所有点的坐标
                positions = geoData.coordinates;
                break;

            case "MultiLineString":
                // 处理 MultiLineString 类型，返回所有线的坐标
                geoData.coordinates.forEach(line => {
                    positions.push(...line); // 展开每条线的坐标
                });
                break;

            case "MultiPolygon":
                // 处理 MultiPolygon 类型，返回所有多边形的坐标
                geoData.coordinates.forEach(polygon => {
                    polygon.forEach(ring => {
                        positions.push(...ring); // 展开每个多边形的环
                    });
                });
                break;

            default:
                console.error("Unsupported geometry type:", geoData.type);
                break;
        }
    }

    return positions;
}

export function getPositionsFromAdminDivisionData_zd(geom) {
    let positions = [];
    let geoData = JSON.parse(geom).coordinates[0][0];
    positions = returnMinOrMaxFromLonLatList(geoData);
    return positions;
}

function returnMinOrMaxFromLonLatList(list) {
    let positions = [];
    let minLon, maxLon, minLat, maxLat;
    list.map((pos) => {
        if (pos[0] < minLon || !minLon) minLon = pos[0];
        if (pos[0] > maxLon || !maxLon) maxLon = pos[0];
        if (pos[1] < minLat || !minLat) minLat = pos[1];
        if (pos[1] > maxLat || !maxLat) maxLat = pos[1];
    });
    positions = [minLon, minLat, maxLon, maxLat];
    return positions;
}

/* 浙大获取基础地理数据(基础高程数据查询、矢量数据查询接口) */
export async function searchDataJCDL(rules, token) {
    switch (rules.dataType) {
        case 4:   //基础高程数据查询
            // {
            //     "endtime": 0,
            //     "num": 0,
            //     "page": 0,
            //     "rangeJson": "string",
            //     "searchrule": 0,
            //     "starttime": 0
            //   }
            let sendData = {
                num: 10,
                page: 1,
                endtime: rules.endtime ? rules.endtime : -1,
                starttime: rules.starttime ? rules.starttime : -1,
            }
            return new Promise((resolve, reject) => {
                axios.post(`/zdUrl/api/getDem`, sendData, {
                    headers: {
                        Authorization: token,
                    }
                }).then(res => {
                    let data = res.data
                    if (data.code === "0") {
                        resolve(data.data)
                    } else {
                        message.error(data.info);
                        reject("基础高程数据查询检索错误")
                    }
                }).catch(e => {
                    reject(e)
                })
            })
        case 5:   //矢量数据查询
            // {
            //     "endtime": 0,
            //     "num": 0,
            //     "page": 0,
            //     "rangeJson": "string",
            //     "searchrule": 0,
            //     "starttime": 0
            //   }
            let sendData2 = {
                num: 10,
                page: 1,
                endtime: rules.endtime ? rules.endtime : -1,
                starttime: rules.starttime ? rules.starttime : -1,
            }
            return new Promise((resolve, reject) => {
                axios.post(`/zdUrl/api/getVectorDlgData`, sendData2, {
                    headers: {
                        Authorization: token,
                    }
                }).then(res => {
                    let data = res.data
                    if (data.code === "0") {
                        resolve(data.data)
                    } else {
                        message.error(data.info);
                        reject("矢量数据查询检索错误")
                    }
                }).catch(e => {
                    reject(e)
                })
            })
        default:
            return Promise.reject('类型查询错误')
    }
}

/* ---------------- */

//浙大产品文档在线预览接口，获取文档访问路径（目前针对遥感特征地理数据，读取文件显示图谱）
export async function getPreReadFileFromType(dataNames, dataType, token) {
    return new Promise((resolve, reject) => {
        axios.get(`/zdUrl/api/getSpectralCharDocumentPath?dataNames=${dataNames}&dataType=${dataType}`, {
            headers: {
                Authorization: token,
            }
        })
            .then((res) => {
                let data = res.data;
                if (data.code === "0") {
                    resolve(data.data);
                } else {
                    reject("产品文档在线预览接口检索错误")
                }
            }).catch((e) => {
            reject(e)
        })
    })
}

//（我们）获取积分定义，以能够进行下载
export async function getScoreFromType(resourceType) {
    let token = getCookie("token");
    // console.log('获取的token：', token);
    return new Promise((resolve, reject) => {
        axios.get(global.url.score + `/type/getByResourceType?resourceType=${resourceType}`,
            {
                headers: {
                    Authorization: token,
                }
            }
        )
            .then((res) => {
                let data = res.data.payload;
                if (res.data.code === "200") {
                    // let downloadScore = data;
                    resolve(data);
                } else {
                    reject("获取积分定义检索错误")
                }
            }).catch((e) => {
            reject(e)
        })
    })
}

/**
 * 将数据添加至购物车
 * @param {*} data 加购物车的数据条
 * @returns {boolean} 加购物车结果
 */
export async function saveCartForAll(data) {
    return new Promise((resolve, reject) => {
        axios({
            url: global.url.order + '/shop/save',
            method: 'post',
            data: [data]
        }).then(res => {

            if (res.data.code === '200') {
                resolve(true)
            } else {
                resolve(false)
            }
        }).catch(err => {
            reject(err)
        })
    })
}

/* 我们————获取对应国家、省份、城市、县市的geoJson */
export async function getGeoJsonFromArea(data) {
    if (data.length === 0) return;
    let query = global.url.getGeoJson + `/getGeoJson`;
    let sendData = {};
    // let dataList = data.split('/');
    let dataList = data;
    console.log(dataList)
    if (dataList.includes('市辖区') || dataList.includes('香港特别行政区') || dataList.includes('澳门特别行政区')) {
        if (dataList[0]) {
            sendData.country = dataList[0];
            query += `?country=${sendData.country}`;
        }
        if (dataList[1]) {
            sendData.province = dataList[1];
            query += `&province=${sendData.province}`;
        }
        if (dataList[3]) {
            sendData.city = dataList[3];
            query += `&city=${sendData.city}`;
        }
    } else {
        if (dataList[0]) {
            sendData.country = dataList[0];
            query += `?country=${sendData.country}`;
        }
        if (dataList[1]) {
            sendData.province = dataList[1];
            query += `&province=${sendData.province}`;
        }
        if (dataList[2]) {
            sendData.city = dataList[2];
            query += `&city=${sendData.city}`;
        }
        if (dataList[3]) {
            sendData.district = dataList[3];
            query += `&district=${sendData.district}`;
        }
    }

    return new Promise((resolve, reject) => {
        axios.get(query)
            .then(res => {
                if (res.data.code === '200') {
                    // console.log("getGeoJsonFromArea",res)
                    if (!res.data.payload) {
                        message.error("error");
                        return;
                    }
                    resolve(res.data.payload.url)
                } else {
                    resolve(false)
                }
            }).catch(err => {
            reject(err)
        })
    })
}

/* 我们————获取对应国家、省份、城市、县市的geoJson的坐标制作成gem */
export async function getGeoJsonFromUrlToGem(url) {
    let temp = "http://10.0.36.106:8888";
    let sendUrl = url.replace(temp, "/getGeoJson");
    let query = sendUrl;
    return new Promise((resolve, reject) => {
        axios.get(query)
            .then(res => {
                console.log("getGeoJsonFromUrlToGem", query);
                if (res.data.features) {
                    resolve(res.data)
                } else {
                    resolve(false)
                }
            }).catch(err => {
            reject(err)
        })
    })
}

/* 我们————输入行政区域，返回对应的gem */
export async function getCountryNameToGem(data) {
    let sendData = data.split('/');
    let url = await getGeoJsonFromArea(sendData);
    let json = await getGeoJsonFromUrlToGem(url);
    console.log("getCountryNameToGem--json", json);
    let tempGem = {"type": "MultiPolygon", "coordinates": []};
    json.features.map((item) => {
        item.geometry.coordinates.map((coord) => {
            // if (tempGem.coordinates.length >= 1) return;
            tempGem.coordinates.push(coord);
        })
    })
    let gem = {...tempGem};
    console.log("gem", gem);
    return JSON.stringify(gem);
}

export async function returnFILTERString(obj, selectedtype) {

    try {
        let {
            satelliteSelectValue,
            areaSelectValue,
            minCloud,
            maxCloud,
            selectProductNumberType,
            productNumber,
            trackNum,
            fromTime,
            endTime,
            nowSelectProductCategory,
            nowSelectProductSelectType,
            selectMode,
            selectClass,
            level //3-5参数
        } = obj
        let {satelliteidList, sensoridList, satelliteidobj} = dealsatelliteString(satelliteSelectValue)
        let FILTER = '';
        FILTER += returnSatelliteFILTER(obj)//卫星相关的FILTER检索语句
        FILTER += await returnRangeFILTER(obj, selectedtype)//范围相关检索语句
        FILTER += returnCloudFILTER(obj)//云量相关检索语句
        if (selectProductNumberType === '产品号') {
            if (productNumber) {
                FILTER += ` and productid in ('${productNumber}')`;
            }
        } else {
            if (productNumber) {
                FILTER += ` and sceneid in ('${productNumber}')`;
            }
        }
        if (trackNum) {
            FILTER += ` and orbitid in ('${trackNum}')`;
        }
        if (fromTime) {
            FILTER += ` and producetime>=${timestampToDateTime(fromTime)}and producetime<=${timestampToDateTime(endTime)}`;
        }
        if (selectClass === '信息瓦片') {
            FILTER += ` and level in ('${level}')`;
        }
        return FILTER
    } catch (error) {
        throw new Error(error)
    }
}

//返回卫星相关的FILTER检索语句
function returnSatelliteFILTER(obj) {
    let {selectClass, satelliteSelectValue, selectSensoryType, resourceType} = obj
    let {satelliteidList, sensoridList, satelliteidobj} = dealsatelliteString(satelliteSelectValue)
    let returnString = ''
    if (resourceType === "产品瓦片") return ""
    if (satelliteidList.length === 0 && sensoridList.length === 0) {
        if (selectClass !== '信息瓦片')
            returnString = `satelliteid IS NOT NULL AND sensorid IS NOT NULL  `;
        else if (resourceType === "产品瓦片")
            returnString = ``;
        else
            returnString = `satelliteid in ('') AND sensorid in ('')`;
    } else {
        if (selectSensoryType === '雷达传感器')
            returnString = `satellite in ('${satelliteidList.join("','")}') and imagingmode in ('${sensoridList.join("','",)}')`;
        else
            returnString = `satelliteid in ('${satelliteidList.join("','")}') and sensorid in ('${sensoridList.join("','",)}')`;
    }
    return returnString
}

//返回范围相关检索语句
async function returnRangeFILTER(obj, selectedtype) {
    try {
        let {
            selectMode,
            selectSensoryType,
            coverageMethod,
            areaSelectValue,
            maxCloud,
            minCloud,
            endTime,
            fromTime,
            nowSelectProductCategory,
            selectClass,
            nowSelectProductSelectType,
            satelliteSelectValue
        } = obj
        let {satelliteidobj} = dealsatelliteString(satelliteSelectValue)
        let FILTER = ''
        switch (selectedtype) {
            case '0-2级数据':
                if (selectSensoryType === '光学传感器' && coverageMethod === "单次全覆盖") {
                    let allsatelliteid = ''
                    for (let value in satelliteidobj) {
                        allsatelliteid = allsatelliteid + satelliteidobj[value].substring(0, satelliteidobj[value].length - 1) + ';'
                    }
                    let {data} = await getOpticalFullCoverV2({
                        cloudRangeMax: maxCloud,
                        cloudrangemin: minCloud,
                        endtime: endTime,
                        starttime: fromTime,
                        searchrule: 1,
                        satellites: allsatelliteid,
                        rangeJson: areaSelectValue.rangeJson ? areaSelectValue.rangeJson : undefined,
                        sort: "1",
                        num: 10,
                        page: 1
                    })
                    let str = JSON.parse(data.info)
                    let dataidStr = str.join(',')
                    FILTER += ` and qrstcode in (${dataidStr})`
                } else {
                    if (areaSelectValue.rangeJson) {
                        let wkt = WKT.convert(JSON.parse(obj.areaSelectValue.rangeJson))
                        // FILTER += wkt;
                        FILTER += ` and INTERSECTS(geom,${wkt})`
                    }
                }
                break;
            case '3-5级产品':
                if (selectMode === "单次全覆盖") {
                    if (selectClass === "景产品") {
                        let {data} = await getImageProdFullCovers(obj)
                        if (data.data.total !== 0) {
                            FILTER += ` and qrstcode in ${data.info.replaceAll(`'`, '')}`
                        }
                    } else {
                        let wkt = WKT.convert(JSON.parse(obj.areaSelectValue.rangeJson))
                        // FILTER += wkt;
                        FILTER += ` and INTERSECTS(geom,${wkt})`
                    }
                } else {
                    if (areaSelectValue.rangeJson) {
                        let wkt = WKT.convert(JSON.parse(obj.areaSelectValue.rangeJson))
                        // FILTER += wkt;
                        FILTER += ` and INTERSECTS(geom,${wkt})`
                    }
                }
                if (nowSelectProductCategory && selectClass === "景产品")
                    FILTER += ` and producetype in ('${nowSelectProductCategory}') and producename in ('${nowSelectProductSelectType}')`;
                break;
            default:
                break;
        }
        return FILTER
    } catch (error) {
        throw new Error('范围信息出错')
    }
}

//返回云量相关检索语句
function returnCloudFILTER(obj) {
    let {selectSensoryType, minCloud, maxCloud, selectClass, resourceType} = obj
    let FILTER = ''
    if (selectSensoryType === '雷达传感器' || selectSensoryType === '大气传感器') return FILTER
    if (minCloud || minCloud == 0) {
        if (selectClass !== '信息瓦片')
            FILTER += ` and cloudpercent>=${minCloud} and cloudpercent<=${maxCloud}`
        else if (resourceType === "产品瓦片")
            FILTER += `cloud>=${minCloud} and cloud<=${maxCloud}`;
        else
            FILTER += ` and cloud>=${minCloud} and cloud<=${maxCloud}`;
    }
    return FILTER
}


function timestampToDateTime(timestamp) {
    const date = new Date(timestamp); // 如果timestamp是数值，直接作为Date的参数
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const seconds = date.getSeconds().toString().padStart(2, '0');
    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
}

//0-2光学传感器获取全部产品id
export async function getOpticalFullCoverV2(info) {
    return axios(`${window.url.interfaceUrl}/getOpticalFullCoverV2?sort=1`, {
        method: 'POST',
        data: {
            cloudRangeMax: info.cloudRangeMax,
            cloudrangemin: info.cloudrangemin,
            endtime: info.endtime ? info.endtime : -1,
            satsensor: info.satellites,
            starttime: info.starttime ? info.starttime : -1,
            searchrule: info.searchrule,
            rangeJson: info.rangeJson,
            sceneid: [],
            productid: [],
            // sort: info.sort,
            num: info.num,
            page: info.page,
        },
    });
}

//3-5景产品获取全部产品id
export async function getImageProdFullCovers(info) {
    let {satelliteidList, sensoridList} = dealsatelliteString(info.satelliteSelectValue)
    return axios(`${window.url.interfaceUrl}/getImageProdFullCovers?sort=1`, {
        method: 'POST',
        data: {
            cloudRangeMax: info.maxCloud,
            cloudrangemin: info.minCloud,
            endtime: info.endTime ? info.endTime / 1000 : -1,
            num: info.num,
            page: info.page,
            rangeJson: info.areaSelectValue.rangeJson ? info.areaSelectValue.rangeJson : undefined,   //等待获取全球geojson后加入
            satelliteid: [...satelliteidList],
            searchrule: 1,        //默认相交
            sensorid: [...sensoridList],
            starttime: info.fromTime ? info.fromTime / 1000 : -1,
            producetype: info.nowSelectProductCategory,
            producename: info.nowSelectProductSelectType
        },
    });
}

/**
 * 获取典型地物特征数据卫星分辨率选项
 * @returns {Promise<void>}
 */
export async function getUniqueOpticalResolution() {
    return new Promise((resolve, reject) => {
        axios.get(global.url.interfaceUrl + '/getUniqueOpticalResolution')
            .then(res => {
                if (res.data.code === '0') {
                    resolve(res.data)
                } else {
                    resolve(false)
                }
            }).catch(err => {
            reject(err)
        })
    })
}

export async function getOpticalTable(onename = "", twoname = "", threename = "") {
    return new Promise((resolve, reject) => {
        axios.get(`${global.url.interfaceUrl}/getOpticalTable?oneName=${onename}&threeName=${threename}&twoName=${twoname}`)
            .then(res => {
                if (res.data.code === '0') {
                    resolve(res.data)
                } else {
                    resolve(false)
                }
            }).catch(err => {
            reject(err)
        })
    })
}

export async function getOpticalQueryDataInquire(rules) {
    console.log('典型地物特征光谱数据检索条件:', rules);
    let sendData = {
        database: "遥感应用特征数据库",
        firstDirectory: '典型地物光谱目标光学特性数据',
        type: '典型地物光谱目标光学特性数据',
        imageResolutions: rules.selectedResolutions,
        sampleType: rules.selectedThreenames,
        dateRange: [rules.fromTime, rules.endTime],
        num: rules.num,
        page: rules.page,
        searchrule: rules.areaSelectValue.selectTopologyType,
        endtime: rules.endTime ? rules.endTime / 1000 : -1,
        starttime: rules.fromTime ? rules.fromTime / 1000 : -1,
        "rangeJson": rules.areaSelectValue.rangeJson ? rules.areaSelectValue.rangeJson : undefined,   //等待获取全球geojson后加入
    }
    let query = global.url.interfaceUrl + '/getOpticalQueryDataInquire';
    return new Promise((resolve, reject) => {
        axios.post(query, sendData).then(res => {
            let data = res.data
            if (data.code === "0") {
                async function text() {
                    resolve(data.data)
                }
                text();
                // resolve(data.data)
            } else {
                // message.error(data.info);
                reject("检索错误")
            }
        }).catch(e => {
            reject(e)
        })
    })
}

export async function searchDataGFBL_zd(rules){
    console.log('高分辨率数据集检索条件:', rules);
    let sendData = {
        dataType: rules.SelectDataType,
        endTime: rules.endTime,
        imageResolution: rules.imageResolution,
        num: rules.num,
        page: rules.page,
        payloadType: rules.payloadType,
        // siteName: rules.siteName,
        startTime: rules.fromTime
    }
    let query = global.url.interfaceUrl + '/getNationalLandCoverTypeData';
    return new Promise((resolve, reject) => {
        axios.post(query, sendData).then(res => {
            let data = res.data
            if (data.code === "0") {
                async function text() {
                    resolve(data.data)
                }
                text();
                // resolve(data.data)
            } else {
                // message.error(data.info);
                reject("检索错误")
            }
        }).catch(e => {
            reject(e)
        })
    })
}

export async function getDXDWDownloadUrl(fileName) {
    let query = `${global.url.interfaceUrl}/downloadDataUrl?name=${fileName}`;
    return new Promise((resolve, reject) => {
        axios.post(query).then(res => {
            let data = res.data
            if (data.code === "0") {
                resolve(data)
            } else {
                message.error(data.info);
                reject("检索错误")
            }
        }).catch(e => {
            reject(e)
        })
    })
}